import { useLayoutEffect, useMemo, useRef } from 'react';

/**
 * Aimed to be easier to use than useCallback and solve problems raised in this ticket.
 * useEventCallback doesn't need any dependencies list. The returned function should not be used during rendering.
 * https://www.npmjs.com/package/use-event-callback
 *
 * but with improved typings
 *
 * https://github.com/pmndrs/react-three-fiber/blob/7875aef5ab1c07736c51231bbb1eacb31ecb705f/packages/fiber/src/core/utils.tsx#L61
 * https://github.com/dmaretskyi/react-use-mutable/blob/master/src/useMutableCallback.ts
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useMutableCallback = <T extends (...args: any) => any>(fn: T): T => {
  const ref = useRef(fn);

  useLayoutEffect(() => {
    ref.current = fn;
  });

  return useMemo(
    () =>
      ((...args) => {
        const { current } = ref;
        return current(...args);
      }) as T,
    [],
  );
};
